import type { IObjectSchema } from '@ksyos/koi';
import { Koi } from '@ksyos/koi';

export function getRecipientSchema(allowOrganizationNull = true, allowPractitionerNull = false): IObjectSchema {
    const recipientId = Koi.string().uuid();

    return Koi.object({
        organizationId: allowOrganizationNull ? recipientId.allow(null) : recipientId.required(),
        practitionerId: allowPractitionerNull ? recipientId.allow(null) : recipientId.required(),
    });
}
